module.exports = __webpack_public_path__ + "img/507.f70cfc71.jpg";